import type { OwaDate } from "owa-datetime";
import type { OcpsPolicyFeature, OutlookCloudPolicySettingId } from "./OutlookCloudPolicyTypes";

export enum OcpsPoliciesFetchState {
    NotStarted,
    Fetching,
    Succeeded,
    Failed
}

export interface OutlookCloudPolicyData {
    settingId: OutlookCloudPolicySettingId;
    value: string;
    valueName: string;
    type: string;
}

export type AccountOcpsPolicies = {
    [F in OcpsPolicyFeature]?: Record<OutlookCloudPolicySettingId, OutlookCloudPolicyData>;
};

export interface AccountOcpsPoliciesState {
    policies: AccountOcpsPolicies;
    fetchState: OcpsPoliciesFetchState;
    expirationTime?: OwaDate;
}
